
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M13.12 16C13.81 16 14.27 15.31 14.02 14.68L9.77001 3.87C9.56001 3.34 9.06001 3 8.50001 3C7.94001 3 7.44001 3.34 7.23001 3.87L2.98001 14.68C2.73001 15.31 3.20001 16 3.88001 16C4.28001 16 4.64001 15.75 4.79001 15.37L5.67001 13H11.31L12.21 15.38C12.36 15.75 12.72 16 13.12 16ZM6.43001 11L8.50001 5.48L10.57 11H6.43001ZM20.89 12.29L13.5 19.68L10.53 16.71C10.14 16.32 9.51001 16.32 9.12001 16.71C8.73001 17.1 8.73001 17.73 9.12001 18.12L12.8 21.8C13.19 22.19 13.82 22.19 14.21 21.8L22.29 13.71C22.68 13.32 22.68 12.69 22.29 12.3C21.91 11.91 21.27 11.91 20.89 12.29Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-spellcheck`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconSpellcheck

    ```js
    <b-new-b-icon-spellcheck />
    ```
</docs>


